export function formatTime(isoString?: string): string {
    if (!isoString) return '-';
    try {
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return isoString;
        return date.toLocaleString();
    } catch {
        return isoString;
    }
}


